// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2oQMI","amount":"Amount_amount__2xgqq","tip":"Amount_tip__1-2YS","tipHeader":"Amount_tipHeader__1bGuS","tipsWrap":"Amount_tipsWrap__2L29B"};